import React from "react";

interface Props {}

const AddPlusIcon = (props: Props) => {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4555 10.7082H18.5388V18.5416H10.7055V22.4582H18.5388V30.2916H22.4555V22.4582H30.2888V18.5416H22.4555V10.7082ZM20.4972 0.916565C9.68715 0.916565 0.913818 9.6899 0.913818 20.4999C0.913818 31.3099 9.68715 40.0832 20.4972 40.0832C31.3072 40.0832 40.0805 31.3099 40.0805 20.4999C40.0805 9.6899 31.3072 0.916565 20.4972 0.916565ZM20.4972 36.1666C11.8609 36.1666 4.83049 29.1361 4.83049 20.4999C4.83049 11.8636 11.8609 4.83323 20.4972 4.83323C29.1334 4.83323 36.1638 11.8636 36.1638 20.4999C36.1638 29.1361 29.1334 36.1666 20.4972 36.1666Z"
        fill="#C8C5C5"
      />
    </svg>
  );
};

export default AddPlusIcon;
